import React, { useContext, useState } from 'react'
import DotsLoader from 'shared/components/loaders/dots'
import { CreationToolsContext } from '../../manager'
import CreationToolStep from '../../types/steps'
import { ColumnBlock, ContainerBlock, SplitBlock } from '../blocks'
import Breadcrumbs from '../breadcrumbs'
import Navigation from '../navigation'
import { Text, Title } from '../typography'
import Buttons from './buttons'
import Editor from './editor'
import Fields from './fields'
import List from './list'
import CreationToolsUploadManager from './manager'
import Preview from './preview'
import Terms from './terms'

const STEP = CreationToolStep.Upload

type Props = {
    submitUrl: string
    apiKey?: string
}

const CreationToolsUpload = ({ submitUrl, apiKey }: Props) => {
    const { sources, stepFrames } = useContext(CreationToolsContext)
    const isBulk = sources.length > 1
    const [isProcessing, setIsProcessing] = useState<boolean>(!stepFrames.length && isBulk)
    const description = CreationToolStep.description(STEP)
    return (
        <CreationToolsUploadManager submitUrl={submitUrl} apiKey={apiKey}>
            <ContainerBlock>
                <SplitBlock style={isProcessing ? { opacity: 0, pointerEvents: 'none', maxHeight: '80vh' } : {}}>
                    <ColumnBlock>
                        <div>
                            <Navigation />
                            {stepFrames.length > 0 && !isBulk ? (
                                <Preview />
                            ) : (
                                <List setIsProcessing={setIsProcessing} />
                            )}
                        </div>
                        <Breadcrumbs />
                    </ColumnBlock>
                    <ColumnBlock>
                        <div>
                            <Title>{CreationToolStep.title(STEP)}</Title>
                            {description && <Text>{description}</Text>}
                            <Fields />
                            <Terms />
                        </div>
                        <Buttons />
                    </ColumnBlock>
                </SplitBlock>
                {isProcessing && <DotsLoader isAbsolute />}
            </ContainerBlock>
            <Editor />
        </CreationToolsUploadManager>
    )
}

export default CreationToolsUpload
